import { render } from "./userPasswordVerify.vue?vue&type=template&id=c13230d0&scoped=true"
import script from "./userPasswordVerify.vue?vue&type=script&lang=js"
export * from "./userPasswordVerify.vue?vue&type=script&lang=js"

import "./userPasswordVerify.vue?vue&type=style&index=0&id=c13230d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c13230d0"]])

export default __exports__